import * as yup from 'yup';
import { dogSchema } from '@/features/Sparten/hun/schema/dogSchema/dogSchema';

export const hunSchema = yup.object({
  deckungssumme: yup.string().required().default(''),
  demvRabattiert: yup.bool().default(true),
  laufzeit: yup.string().required().default(''),
  selbstbeteiligung: yup.string().required().default(''),
  tarifgruppe: yup.string().required().default(''),
  vorschaden: yup.string().required().default(''),

  hundeAnzahl: yup.number().min(1).max(5).required().default(1),
  hunde: yup.array().default([dogSchema.getDefault()]).of(dogSchema).required(),
});
